<template style="display: flex">
  <v-card style="width: 60%; margin: 0 auto; padding: 12px" light>
    <v-row>
      <v-col cols="auto">
        <v-icon @click="close">mdi-close</v-icon>
      </v-col>
      <v-spacer></v-spacer>
    </v-row>

    <v-card-title class="card-title ma-0 pa-3">
      <span>Confirm Removing User</span>
    </v-card-title>
    <v-card-text class="card-section-content">
      Are you sure you want to remove the user <b>{{ user.name }}</b> from the
      organization <b>{{ org.display_name }}</b
      >?
    </v-card-text>
    <v-row class="ma-0 pa-0" justify="space-around">
      <v-col cols="auto">
        <v-btn color="primary" outlined class="card-action" @click="close">
          Cancel
        </v-btn>
      </v-col>
      <v-col cols="auto" @click="confirmed_remove_member">
        <v-btn color="primary" class="card-action"> Confirm </v-btn>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import admin_api_caller from "@/javascript/user_org_management";
import {
  ALERT_GENERIC_MESSAGE,
  ALERT_TYPE_SUCCESS,
  ALERT_TYPE_ERROR,
  SUCCESS_REMOVE_USER_MESSAGE,
} from "@/constants/constants.js";
export default {
  name: "RemoveUserCard",
  props: ["user", "org"],

  methods: {
    close: function () {
      this.$emit("close_remove_user");
    },
    confirmed_remove_member: async function () {
      let token = await this.$auth.getTokenSilently();
      let resp = await admin_api_caller
        .remove_org_member(token, this.org, [this.user])
        .then((resp) => {
          if (resp["success"]) {
            return resp["data"];
          }
          return false;
        })
        .catch((e) => {
          console.log(e);
          return false;
        });
      if (resp && resp["response_code"] == 204) {
        this.$emit(
          "close_remove_user",
          ALERT_TYPE_SUCCESS,
          SUCCESS_REMOVE_USER_MESSAGE
        );
      } else {
        this.$emit(
          "close_remove_user",
          ALERT_TYPE_ERROR,
          ALERT_GENERIC_MESSAGE
        );
      }
    },
  },
};
</script>
<style>
.card-title {
  font-family: "Poppins" !important;
  font-weight: 800 !important;
  font-size: 1.2em !important;
}
.card-section-title {
  font-family: "Poppins" !important;
  font-weight: 600 !important;
  font-size: 1.2em !important;
}
.card-section-content {
  font-family: "Poppins" !important;
}
.card-action {
  font-family: "Poppins" !important;
  font-weight: 400 !important;
  font-size: 0.9em !important;
}
</style>
